@use "@fukuri-admins/ui/layout" as *;

.container {
    &_Header {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .title {
        color: text('High');
        @include typography('Jp/20_W6');
    }
    .table {
        padding-top: spacing('20');
    }
}

/* カラム幅（table-layout: fixed 使用時）。幅未指定の 3 列（表示名 / リンク先 / ファイル）が残り幅を均等に分け合う */
.colSortOrder {
  width: 80px;
}

.colIcon {
  width: 80px;
}

.colAction {
  @include colAction;
}

/* 長いテキストを 1 行で省略表示する */
.truncatedCell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dragHandle {
  display: flex;
  align-items: center;
  color: text('Low');
  cursor: grab;

  // svgIcon クラスが color: text('High') を持つため、詳細度を上げて上書きする
  svg {
    color: inherit;
  }

  &:active {
    cursor: grabbing;
  }
}

.deleteItem {
  color: text('Red');
}
